import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subject, defer } from 'rxjs';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { LoaderService } from 'src/app/services/loader.service';
import { OpfoelgningService, ServiceordreService } from 'src/app/api/services';
import { finalize, takeUntil, flatMap, tap } from 'rxjs/operators';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GetServiceordrerRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/get-serviceordrer-request';
import { OpfoelgningAction, OpfoelgningDialogData, OpfoelgningDialogResponse, ServiceordreFilter } from '../../aftale/models';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { OrdreService } from 'src/app/services/ordre.service';
import { OpfoelgningChanged, SignalrService } from 'src/app/services/signalr.service';
import { ServiceordreValidationFailedReasonEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-validation-failed-reason-enum';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { OpfoelgningDialogComponent } from 'src/app/opfoelgning/components/opfoelgning-dialog/opfoelgning-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import moment from 'moment';
import { PaginationCacheService } from 'src/app/services/paginationcache.service';
import { OpfoelgningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { AuthService } from 'src/app/services/auth.service';
import { ExcelDownloadDialogModel } from '../../shared/excel/excel-download-dialog/excel-download-dialog.model';
import { ExcelDocumentTypeEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/excel-document-type-enum';
import { ExcelDocumentHandlerTypeEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/excel-document-handler-type-enum';
import { ExcelDownloadDialogComponent } from '../../shared/excel/excel-download-dialog/excel-download-dialog.component';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { OpfoelgningerService } from 'src/app/services/opfoelgninger.service';

@Component({
  selector: 'app-ordre-list',
  templateUrl: './ordre-list.component.html',
  styleUrls: ['./ordre-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrdreListComponent implements OnInit, OnDestroy {
  canWrite: boolean = false;
  serviceordrer: ServiceordreDto[] = [];
  globalActiveRowID: string = '';
  highlightRowIndex: number;
  ValidationFailedReason = ServiceordreValidationFailedReasonEnum;
  originalPartnerNo: number;
  originalPartnerName: string;

  displayedColumns: string[] = [
    'Serviceaftale.Serviceabonnement.Produkt',
    'opfoelgning',
    'parked',
    'ServiceordreNo',
    'Serviceaftale.OkKundeAftalenr',
    'Opgave',
    'ServiceordreStatus',
    'Partner.Name',
    'Leveringsdato',
    'Oprettid',
    'Ajourtid',
  ];

  unsubscribe$ = new Subject<void>();

  dataSource: any;

  filter: ServiceordreFilter = {
    productIds: ([] = []),
    serviceOrderStateIds: ([] = []),
    opgaveIds: ([] = []),
    partnerNos: ([] = []),
    orderBy: 'Ajourtid',
    orderDir: 'desc',
    showParked: false,
    periodFrom: null,
    periodTo: null,
  };

  rowCount: number;
  pageCount: number;
  searchQuery: string;

  filterKey: string = 'ordre-filter';

  serviceordreStatusEnum = ServiceordreStatusEnum;

  constructor(
    private loader: LoaderService,
    private serviceordre: ServiceordreService,
    private router: Router,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private localStorage: LocalStorageService,
    private ordreService: OrdreService,
    private signalR: SignalrService,
    private dialog: MatDialog,
    private opfoelgningService: OpfoelgningService,
    private notification: NotificationService,
    private paginationCache: PaginationCacheService,
    private auth: AuthService,
    private opfoelgningerService: OpfoelgningerService,
  ) {
    this.dataSource = new MatTableDataSource(this.serviceordrer);
    this.canWrite = this.auth.canWrite;
  }

  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.searchQuery = null;

    this.serviceordrer = [];

    (this.route.queryParams
      .pipe(
        flatMap((queryParams: Params) => {
          const filter: ServiceordreFilter = {
            productIds: ([] = []),
            serviceOrderStateIds: ([] = []),
            opgaveIds: ([] = []),
            partnerNos: ([] = []),
            orderBy: 'Ajourtid',
            orderDir: 'desc',
            showParked: false,
            periodFrom: null,
            periodTo: null,
          };

          const localFilter: ServiceordreFilter = this.localStorage.get(this.filterKey);
          if (localFilter) {
            filter.orderBy = localFilter.orderBy;
            filter.orderDir = localFilter.orderDir;
            filter.serviceOrderStateIds = localFilter.serviceOrderStateIds ?? [];
            filter.opgaveIds = localFilter.opgaveIds ?? [];
            filter.partnerNos = localFilter.partnerNos ?? [];
            filter.showParked = localFilter.showParked;
            filter.periodFrom = localFilter.periodFrom;
            filter.periodTo = localFilter.periodTo;
            filter.productIds = localFilter.productIds ?? [];
          }

          this.searchQuery = '';
          this.page = 1;

          const q = queryParams['q'];
          const serviceOrderStateIds = queryParams['serviceOrderStateIds'];
          const opgaveIds = queryParams['opgaveIds'];
          const partnerNos = queryParams['partnerNos'];
          const orderBy = queryParams['orderBy'];
          const orderDir = queryParams['orderDir'];
          const showParked = queryParams['showParked'];
          const periodFrom = queryParams['periodFrom'];
          const periodTo = queryParams['periodTo'];
          const productIds = queryParams['productIds'];

          if (q) {
            this.searchQuery = q;
          }

          if (orderBy && orderBy != '') {
            filter.orderBy = orderBy;
          }

          if (orderDir && orderDir != '') {
            filter.orderDir = orderDir;
          }

          if (showParked != null) {
            filter.showParked = showParked ? showParked.toLocaleLowerCase() === 'true' : false;
          }

          if (serviceOrderStateIds) {
            if (serviceOrderStateIds instanceof Array) {
              filter.serviceOrderStateIds = serviceOrderStateIds.map(function (x: string) {
                return Number(x);
              });
            } else {
              filter.serviceOrderStateIds.push(Number(serviceOrderStateIds));
            }
          }
          if (opgaveIds) {
            if (opgaveIds instanceof Array) {
              filter.opgaveIds = opgaveIds.map(function (x: string) {
                return Number(x);
              });
            } else {
              filter.opgaveIds.push(Number(opgaveIds));
            }
          }

          if (partnerNos) {
            if (partnerNos instanceof Array) {
              filter.partnerNos = partnerNos.map(function (x: string) {
                return Number(x);
              });
            } else {
              filter.partnerNos.push(Number(partnerNos));
            }
          }

          if (productIds) {
            if (productIds instanceof Array) {
              filter.productIds = productIds;
            } else {
              filter.productIds.push(productIds);
            }
          }

          if (periodFrom) {
            this.filter.periodFrom = moment(periodFrom).toDate();
          }

          if (periodTo) {
            this.filter.periodTo = moment(periodTo).toDate();
          }

          filter.productIds = filter.productIds.filter((v, i, a) => a.indexOf(v) === i);

          filter.serviceOrderStateIds = filter.serviceOrderStateIds.filter((v, i, a) => a.indexOf(v) === i);

          filter.opgaveIds = filter.opgaveIds.filter((v, i, a) => a.indexOf(v) === i);

          filter.partnerNos = filter.partnerNos.filter((v, i, a) => a.indexOf(v) === i);

          this.localStorage.set(this.filterKey, filter);

          this.filter = filter;

          const pagination = this.paginationCache.position;
          if (pagination) {
            this.page = Number(pagination.page);
            this.prevRow = pagination.id;
          }

          return this.getServiceordrer$.pipe(
            tap((response) => {
              this.skip = this.page - 1;
              this.rowCount = response.rowCount;
              this.pageCount = response.pageCount;
              this.serviceordrer = this.serviceordrer = response.serviceordrer;
              this.dataSource = new MatTableDataSource(this.serviceordrer);
            }),
          );
        }),
      )
      .subscribe(() => {}),
      (error) => {
        this.errorHandler.HandleError(error);
      });

    this.signalR.serviceordreChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((serviceordre: ServiceordreDto) => {
      const index = this.serviceordrer.findIndex((x) => x.id == serviceordre.id);
      if (index >= 0) {
        this.serviceordrer[index] = serviceordre;
        this.dataSource = new MatTableDataSource(this.serviceordrer);
      }
    });

    this.signalR.opfoelgningChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((event: OpfoelgningChanged) => {
      const serviceordre = this.serviceordrer.find((x) => x.serviceordreNo == event.entityNo);

      if (serviceordre) {
        serviceordre.opfoelgning = event.opfoelgning;

        let index = serviceordre.opfoelgningList.findIndex((p) => p.id == event.opfoelgning.id);
        if (index >= 0) serviceordre.opfoelgningList.splice(index, 1, event.opfoelgning);
        else serviceordre.opfoelgningList.push(event.opfoelgning);

        this.dataSource = new MatTableDataSource(this.serviceordrer);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  getServiceordrer$ = defer(() => {
    this.loader.show();

    let top = this.page - this.skip;
    let skip = this.skip > this.page ? top - 1 : this.skip;

    const request: GetServiceordrerRequest = {
      searchQuery: this.searchQuery,
      pageTop: top < 1 ? 1 : top,
      pageSkip: skip < 0 ? 0 : skip,
      serviceordreStateDtoIds: this.filter.serviceOrderStateIds,
      productIds: this.filter.productIds,
      opgaveIds: this.filter.opgaveIds,
      partnerNos: this.filter.partnerNos,
      orderBy: this.filter.orderBy,
      orderDir: this.filter.orderDir,
      showParked: this.filter.showParked,
      periodFrom: this.filter.periodFrom ? moment(this.filter.periodFrom).format('YYYY-MM-DD') : null,
      periodTo: this.filter.periodTo ? moment(this.filter.periodTo).format('YYYY-MM-DD') : null,
    };

    return this.serviceordre.getServiceordrer({ caller: EGIS_SERVICE_CALLER, body: request }).pipe(
      tap((response) => {
        this.rowCount = response.rowCount;
        this.pageCount = response.pageCount;
        this.serviceordrer = this.serviceordrer.concat(response.serviceordrer);
        this.dataSource = new MatTableDataSource(this.serviceordrer);
      }),
      finalize(() => {
        this.loader.hide();
      }),
      takeUntil(this.unsubscribe$),
    );
  });

  getProductIcon(serviceordre: ServiceordreDto) {
    return serviceordre.produkt.toLowerCase();
  }

  getNotes(serviceordre: ServiceordreDto) {
    return `${serviceordre.description}\n${serviceordre.fastOrdreNote}`;
  }

  onRowClick(serviceordre: ServiceordreDto) {
    this.router.navigate(['/ordre', serviceordre.serviceordreNo, 'edit', { page: this.page }]);
  }

  more() {
    this.page++;
    this.skip++;
    this.loader.show();
    (this.getServiceordrer$
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
      )
      .subscribe(),
      (error: HttpErrorResponse) => {
        this.errorHandler.HandleError(error);
        this.page -= 1;
      });
  }

  sortData(sort: Sort) {
    this.serviceordrer = [];
    const orderParams: Params = {
      orderBy: sort.active ? sort.active : null,
      orderDir: sort.direction ? sort.direction : null,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: orderParams,
      queryParamsHandling: 'merge',
    });
  }

  handleValidationFailed(event: Event, serviceordre: ServiceordreDto) {
    event.stopPropagation();
    if (serviceordre.serviceordreValidationFailedReason == ServiceordreValidationFailedReasonEnum.CreditCheckFailed) {
      this.ordreService
        .kreditstop$(serviceordre)
        .pipe(
          takeUntil(this.unsubscribe$),
          finalize(() => {
            this.loader.hide();
          }),
        )
        .subscribe(
          () => {},
          (error) => {
            this.errorHandler.HandleError(error);
          },
        );
    } else {
      this.ordreService
        .handleValidationFailed$(serviceordre)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          () => {},
          (error) => {
            this.errorHandler.HandleError(error);
          },
        );
    }
  }

  opfoelgning(event: Event, serviceordre: ServiceordreDto) {
    event.stopPropagation();

    const data: OpfoelgningDialogData = {
      entityNo: serviceordre.serviceordreNo,
      serviceordre: serviceordre,
      opfoelgninger: serviceordre.opfoelgningList,
    };
    let dialogRef = this.dialog.open(OpfoelgningDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data,
    });

    dialogRef.afterClosed().subscribe((response: OpfoelgningDialogResponse) => {
      if (response) {
        this.onOpfoelgningChanged(response);
      }
    });
  }

  onOpfoelgningChanged(response: OpfoelgningDialogResponse) {
    if (response.action == OpfoelgningAction.Upsert) {
      this.loader.show();

      this.opfoelgningService
        .upsertServiceordreOpfoelgning({
          caller: EGIS_SERVICE_CALLER,
          body: {
            id: response.opfoelgning.id,
            note: response.opfoelgning.note,
            deadline: response.opfoelgning.deadline ? new Date(response.opfoelgning.deadline).toOkDateString() : null,
            prioritet: response.opfoelgning.priority,
            entityNo: response.opfoelgning.entityNo,
            parker: response.park,
          },
        })
        .pipe(
          finalize(() => {
            this.loader.hide();
          }),
          takeUntil(this.unsubscribe$),
        )
        .subscribe({
          next: () => {
            this.notification.success('Opfølgning er gemt.');
          },
          error: (error) => {
            this.errorHandler.HandleError(error);
          },
        });
    } else if (response.action == OpfoelgningAction.Delete) {
      this.opfoelgningService
        .removeServiceordreOpfoelgning({ caller: EGIS_SERVICE_CALLER, id: response.opfoelgning.id })
        .pipe(
          finalize(() => {
            this.loader.hide();
          }),
          takeUntil(this.unsubscribe$),
        )
        .subscribe({
          next: () => {
            this.notification.success('Opfølgning er fjernet.');
            const serviceordre = this.serviceordrer.find((p) => p.serviceordreNo == response.opfoelgning.entityNo);
            if (serviceordre) {
              let index = serviceordre.opfoelgningList.findIndex((p) => p.id == response.opfoelgning.id);
              if (index >= 0) serviceordre.opfoelgningList.splice(index, 1);
            }
          },
          error: (error) => {
            this.errorHandler.HandleError(error);
          },
        });
    }
  }

  skip: number = 0;
  page: number = 1;
  prevRow: number = null;
  highLight(id: number) {
    var row = this.serviceordrer.find((p) => p.serviceordreNo == id);
    if (row) this.globalActiveRowID = row.id.toString();
  }

  opfoelgninger(serviceordre: ServiceordreDto): string {
    return serviceordre.opfoelgningList.map((o) => o.note).join('\n');
  }

  useropfolgninger(dto: ServiceordreDto): Array<OpfoelgningDto> {
    return dto.opfoelgningList.filter((p) => p.user == this.auth.username);
  }

  button(serviceordre: ServiceordreDto) {
    return this.opfoelgningerService.serviceordreState(serviceordre, this.auth.username);
  }

  download() {
    const request: GetServiceordrerRequest = {
      searchQuery: this.searchQuery,
      serviceordreStateDtoIds: this.filter.serviceOrderStateIds,
      opgaveIds: this.filter.opgaveIds,
      partnerNos: this.filter.partnerNos,
      orderBy: this.filter.orderBy,
      orderDir: this.filter.orderDir,
      showParked: this.filter.showParked,
      periodFrom: this.filter.periodFrom ? moment(this.filter.periodFrom).format('YYYY-MM-DD') : null,
      periodTo: this.filter.periodTo ? moment(this.filter.periodTo).format('YYYY-MM-DD') : null,
    };

    const data: ExcelDownloadDialogModel = {
      documentType: ExcelDocumentTypeEnum.Serviceordrer,
      handlerType: ExcelDocumentHandlerTypeEnum.Default,
      filter: JSON.stringify(request),
    };
    this.dialog.open(ExcelDownloadDialogComponent, {
      data: data,
    });
  }
}
